import React from "react";
import { ChevronRight } from "lucide-react";

const DemoFormCard = () => {
  return (
    <div className="bg-white rounded-[2rem] p-8 md:p-10 shadow-sm border border-slate-100">
      <h2 className="text-2xl font-bold text-slate-900 mb-8">Request a Demo</h2>

      <form className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Full Name */}
          <div className="md:col-span-2">
            <label className="block text-sm font-bold text-slate-700 mb-2">
              Full Name
            </label>
            <input
              type="text"
              placeholder="Enter your full name"
              className="w-full px-5 py-4 bg-slate-50 border border-slate-100 rounded-2xl text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all"
            />
          </div>

          {/* Work Email */}
          <div className="md:col-span-2">
            <label className="block text-sm font-bold text-slate-700 mb-2">
              Work Email
            </label>
            <input
              type="email"
              placeholder="Enter your practice email"
              className="w-full px-5 py-4 bg-slate-50 border border-slate-100 rounded-2xl text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all"
            />
          </div>

          {/* Practice Name */}
          <div className="md:col-span-2">
            <label className="block text-sm font-bold text-slate-700 mb-2">
              Practice Name
            </label>
            <input
              type="text"
              placeholder="Enter your clinic or organization name"
              className="w-full px-5 py-4 bg-slate-50 border border-slate-100 rounded-2xl text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all"
            />
          </div>

          {/* Your Role */}
          <div>
            <label className="block text-sm font-bold text-slate-700 mb-2">
              Your Role
            </label>
            <select className="w-full px-5 py-4 bg-slate-50 border border-slate-100 rounded-2xl text-slate-900 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all appearance-none cursor-pointer">
              <option>Dentist</option>
              <option>Practice Manager</option>
              <option>DSO Executive</option>
              <option>Marketing Director</option>
              <option>Other</option>
            </select>
          </div>

          {/* Number of Locations */}
          <div>
            <label className="block text-sm font-bold text-slate-700 mb-2">
              Number of Locations
            </label>
            <select className="w-full px-5 py-4 bg-slate-50 border border-slate-100 rounded-2xl text-slate-900 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all appearance-none cursor-pointer">
              <option>1</option>
              <option>2-5</option>
              <option>6-20</option>
              <option>20+</option>
            </select>
          </div>

          {/* Monthly Consultation Volume */}
          <div>
            <label className="block text-sm font-bold text-slate-700 mb-2">
              Monthly Consultation Volume
            </label>
            <select className="w-full px-5 py-4 bg-slate-50 border border-slate-100 rounded-2xl text-slate-900 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all appearance-none cursor-pointer">
              <option>Under 50</option>
              <option>50-100</option>
              <option>100-200</option>
              <option>200+</option>
            </select>
          </div>

          {/* Primary Interest */}
          <div>
            <label className="flex items-center justify-between text-sm font-bold text-slate-700 mb-2">
              Primary Interest
            </label>
            <select className="w-full px-5 py-4 bg-slate-50 border border-slate-100 rounded-2xl text-slate-900 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all appearance-none cursor-pointer">
              <option>Boost case acceptance</option>
              <option>Website lead capture</option>
              <option>All-on-X marketing</option>
              <option>Multi-location deployment</option>
              <option>Just exploring</option>
            </select>
          </div>

          {/* Message */}
          <div className="md:col-span-2">
            <label className="block text-sm font-bold text-slate-700 mb-2">
              Message
            </label>
            <textarea
              rows={4}
              placeholder="Tell us about your practice goals or questions..."
              className="w-full px-5 py-4 bg-slate-50 border border-slate-100 rounded-2xl text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all resize-none"
            />
          </div>
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className="w-full sm:w-auto flex items-center justify-center gap-2 rounded-full bg-[#0066ff] px-10 py-5 text-white transition-all hover:scale-[1.02] shadow-xl shadow-blue-500/30 text-lg font-bold group relative overflow-hidden mt-6"
          style={{
            background:
              "radial-gradient(circle at center, #3b82f6 0%, #0066ff 100%)",
          }}
        >
          <div className="absolute inset-0 bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none blur-xl" />
          Request a Demo
          <div className="flex items-center text-current">
            <ChevronRight className="h-4 w-4 opacity-40 group-hover:translate-x-0.5 transition-transform" />
            <ChevronRight className="h-5 w-5 opacity-70 -ml-2.5 group-hover:translate-x-0.5 transition-transform delay-75" />
            <ChevronRight className="h-6 w-6 opacity-100 -ml-3.5 group-hover:translate-x-0.5 transition-transform delay-150" />
          </div>
        </button>
      </form>
    </div>
  );
};

export default DemoFormCard;
